import { Flex, Input, InputLabel, Text } from "@fluentui/react-northstar";
import styled from "styled-components";

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 2;
    align-items: center;
    justify-items: center;
    padding: 8px 12px;
    gap: 8px;
    border-radius: 8px;
`;

export const TextHoursCenter = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-1424242,
        #424242
    );

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
`;

export const RoundedArrow = styled(Flex)`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: white;
`;

export const WrapperCards = styled(Flex)`
    border-radius: 8px;
    background: rgba(232, 235, 250, 0.75);
`;

export const TextLabel = styled(Text)`
    color: ${({ $primary }) =>
        !$primary
            ? "var(--light-theme-rest-foreground-default-foreground-1424242, #424242)"
            : "var(--color-primary)"};

    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px; /* 120% */
`;
export const TextHours = styled(Text)`
    color: ${({ $primary }) =>
        !$primary
            ? "var(--light-theme-rest-foreground-default-foreground-1424242, #424242)"
            : "var(--color-primary)"};

    font-size: 18px;
    font-style: normal;
    font-weight: ${({ $primary }) => (!$primary ? "400" : "600 ")};
    line-height: 24px; /* 133.333% */
`;
export const Card = styled(Flex)``;
export const Box = styled(Flex)`
    padding: 12px 16px;
`;

export const SInput = styled(Input)`
    background-color: #f5f5f5;
    input {
        padding-right: 60px;
    }
    .ui-input__icon {
        right: 0px;
        background-color: #f0f0f0;
        padding-inline: 10px;
    }
`;

export const SInputLabel = styled(InputLabel)`
    color: var(--Light-theme-Rest-Foreground-Default-Foreground-2, #616161);

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
`;
